var React = require('react');

function FbInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"32","height":"32.276","fill":"#FFF","rx":"2","key":0}),React.createElement("path",{"fill":"#005285","d":"M21.789 32.258V21.216h3.538l.53-4.303h-4.068v-2.748c0-1.246.33-2.095 2.036-2.095H26V8.22c-.376-.052-1.668-.17-3.17-.17-3.136 0-5.283 2.006-5.283 5.689v3.174H14v4.303h3.547v11.042h4.242z","key":1})]));
}

FbInline.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33"};

module.exports = FbInline;

FbInline.default = FbInline;
